import { render, staticRenderFns } from "./SpreadSheet.vue?vue&type=template&id=57f25754"
import script from "./SpreadSheet.vue?vue&type=script&lang=js"
export * from "./SpreadSheet.vue?vue&type=script&lang=js"
import style0 from "./SpreadSheet.vue?vue&type=style&index=0&id=57f25754&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports